/**
 * Фразы по-умолчанию для селекта
 * Можно заменить через пропсы:
 * - loading (пропс loadingText)
 * - noOptions (пропс noOptionsMessage)
 * - placeholder (пропс placeholder)
 */
export const SELECT_TEXTS = {
  loading: 'Минутку, ищем данные...',
  noOptions: 'Пока нет данных',
  noSearchResults: 'Похоже, такого нет',
  placeholder: 'Выберите из списка',
  readonly: 'Выбор недоступен',
} as const;
